import { render } from "./DashboardSectionRenderer.vue?vue&type=template&id=76b4905d"
import script from "./DashboardSectionRenderer.vue?vue&type=script&lang=js"
export * from "./DashboardSectionRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__